import React, {useState, useEffect} from 'react'
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from 'react-router-dom';
import { deleteJobPost } from '../../utils/api-services/job';
import Confirm from '../../global/components/Confirm';
import { color } from 'highcharts';

const JobPostItem = ({obj}) => {

    const [hover, setHover] = useState(false);

    function handleHover(state){
        setHover(state);
    };

    const styles = {
        item: {
            flex: 1,
            background: '#fff',
            minWidth: 260,
            margin: '20px 10px',
            padding: '10px 20px',
            border: hover? '1px solid #333': '1px solid #ccc',
            borderRadius: 5,
        },
        title:{
            color: '#363636',
            fontSize: 16,
            fontWeight: 600,
            marginBottom: 5,
        },
        description:{
            color: '#363636',
            fontSize: 13,
        },
        link: {
            textDecoration: 'none'
        },
        org: {
            name:{
                color: '#333',
                marginBottom: 15,
                fontSize: 16,
            }
        },
        feature:{
            wrap:{
                padding: '20px 0px'
            },
            items:{
                display: 'flex',
                flexWrap: 'wrap'
            },
            item: {
                background: '#f8f5fe',
                color: '#717886',
                marginTop: 5,
                marginRight: 10,
                marginBottom: 5,
                padding: '2px 10px',
                borderRadius: 3,
                fontSize: 15,
            }
        },
    }

    return (
        <div style={styles.item} onMouseEnter={()=>handleHover(true)} onMouseLeave={()=>handleHover(false)}>
            <a href={`/job/${obj.Slug}`} style={styles.link}>
                <h2 style={styles.title}>{obj.Title}</h2>

                <div style={styles.org.name}>{obj.OrganizationName}</div>

                <div style={styles.feature.items}>
                    {obj.Qualification!="" && <div style={styles.feature.item}>{obj.Qualification}</div>}
                    {obj.ExperienceLevel!="" && <div style={styles.feature.item}>{obj.ExperienceLevel}</div>}
                    {obj.ExperienceLength!="" && <div style={styles.feature.item}>{obj.ExperienceLength} Experience</div>}
                    {obj.JobType!="" && <div style={styles.feature.item}>{obj.JobType}</div>}
                    {obj.WorkMode!="" && <div style={styles.feature.item}>{obj.WorkMode}</div>}
                    {obj.Salary!="" && <div style={styles.feature.item}>{obj.Salary}</div>}
                </div>
            </a>
        </div>
    )
}

export default JobPostItem